import React, { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import axios from "axios";
import BtnLoader from "Components/Common/Loader/BtnLoader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 400,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 8,
  boxShadow: 24,
  p: 4,
};

const CoinWarningPopup = ({
  warnPopupOpen,
  handleClose,
  coinDetails,
  fetchCoinPlans,
  staffId,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const createStaffActivityLog = async (actionType, description) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/staffs-activity-log/create-staffs-activity`,
        {
          staff: staffId,
          action: actionType,
          description,
        }
      );
    } catch (error) {
      console.error("Activity log failed:", error.message);
    }
  };
  const deleteCoin = async () => {
    setIsLoading(true);

    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/coin-plan/deletecoin-plans/${coinDetails?._id}`
      );

      //  Activity Log Integration
      await createStaffActivityLog(
        "DELETE_COIN_PLAN",
        `Coin package "${coinDetails?.title}" deleted (Amount: ₹${coinDetails?.purchaseAmount}, Coins: ${coinDetails?.coinAmount})`
      );

      fetchCoinPlans();
      handleClose();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={warnPopupOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="w-full">
          <div className="mb-4 flex items-center">
            <div className="mr-2 text-2xl font-bold">
              {coinDetails?.title} Packages
            </div>
            {/* <h2 className="text-xl font-semibold tracking-wide">
                            {emojiDetails?.name}
                        </h2> */}
          </div>
          <p className="mb-6 tracking-wide">
            Do you really want to delete this Coin Packages?
          </p>
          <div className="flex justify-end space-x-4 tracking-wide">
            <button
              className="rounded bg-gray-300 px-4 py-2 text-gray-800 hover:bg-gray-400"
              onClick={handleClose}
            >
              Cancel
            </button>

            {isLoading ? (
              <button className="rounded bg-[#c51369] px-4 py-2 text-white hover:bg-[#a10f5b]">
                <BtnLoader />
              </button>
            ) : (
              <button
                onClick={() => deleteCoin()}
                className="rounded bg-[#c51369] px-4 py-2 text-white hover:bg-[#a10f5b]"
              >
                Yes, Delete
              </button>
            )}
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default CoinWarningPopup;
